export const BUSINESS_EKINET_RAILWAY_TICKET_TYPE = 4;

export const BUSINESS_EKINET_IC_LINK_URL = 'https://www.eki-net.com/top/jrticket/guide/reserve/ic_link.html';
export const BUSINESS_EKINET_IC_REGISTER_URL = 'https://www.eki-net.com/top/member/guide/ic_register.html';
export const BUSINESS_EKINET_SUICA_AREA_URL = 'https://www.jreast.co.jp/suica/area/';
export const BUSINESS_EKINET_TICKETLESS_URL = 'https://www.eki-net.com/top/ticketless/#headerL_02';

export type BusinessEkinetTicketlessNoticeLink = {
  label: string;
  url: string;
};

export type BusinessEkinetTicketlessNotice = {
  introLine: string;
  icSectionTitle: string;
  icBulletLine: string;
  icLinks: BusinessEkinetTicketlessNoticeLink[];
  expressSectionTitle?: string;
  expressOnlyBulletLine?: string;
  expressAreaBulletPrefix?: string;
  expressAreaBulletSuffix?: string;
  expressInlineLink?: BusinessEkinetTicketlessNoticeLink;
  expressFooterLink?: BusinessEkinetTicketlessNoticeLink;
};

type TransportLike = {
  railwayTicketType?: number | null;
  isExpress?: boolean;
  transportType?: string;
};

export const isBusinessEkinetTransport = (transport: TransportLike | null | undefined): boolean =>
  transport?.railwayTicketType === BUSINESS_EKINET_RAILWAY_TICKET_TYPE;

export const hasBusinessEkinetTransport = (transports: ReadonlyArray<TransportLike> | null | undefined): boolean =>
  (transports ?? []).some(isBusinessEkinetTransport);

export const hasBusinessEkinetExpressTransport = (
  transports: ReadonlyArray<TransportLike> | null | undefined
): boolean =>
  (transports ?? []).some(
    transport =>
      isBusinessEkinetTransport(transport) &&
      (transport.isExpress === true || transport.transportType === 'express')
  );

export const buildBusinessEkinetTicketlessNotice = (includeExpress: boolean): BusinessEkinetTicketlessNotice => {
  const notice: BusinessEkinetTicketlessNotice = {
    introLine: '※ チケットレスでのご提供です。',
    icSectionTitle: '■ICカードのご利用について',
    icBulletLine:
      '・予約内容と人数分の交通系ICカードの紐づけが必要です。ご乗車までに予約内容とICカードの紐づけを行ってください。',
    icLinks: [
      { label: 'ICカードと座席の紐づけについて', url: BUSINESS_EKINET_IC_LINK_URL },
      { label: 'ICカード情報の登録・変更・削除方法', url: BUSINESS_EKINET_IC_REGISTER_URL }
    ]
  };

  if (!includeExpress) {
    return notice;
  }

  return {
    ...notice,
    expressSectionTitle: '■「在来線チケットレス特急サービス」ご利用にあたっての注意事項',
    expressOnlyBulletLine: '・「在来線チケットレス特急券サービス」は「特急券のみ」の商品です。',
    expressAreaBulletPrefix: '・交通系ICカード等（',
    expressAreaBulletSuffix: '内完結）でご乗車の場合、乗車券のお申込みは不要です。',
    expressInlineLink: { label: '利用可能エリア', url: BUSINESS_EKINET_SUICA_AREA_URL },
    expressFooterLink: {
      label: '在来線チケットレス特急券サービスをご利用の場合',
      url: BUSINESS_EKINET_TICKETLESS_URL
    }
  };
};

export const buildBusinessEkinetTicketlessCalendarLines = (
  includeExpress: boolean,
  addLink: (url: string, text?: string) => string
): string[] => {
  const notice = buildBusinessEkinetTicketlessNotice(includeExpress);
  const lines = [
    notice.introLine,
    notice.icSectionTitle,
    notice.icBulletLine,
    ...notice.icLinks.map(link => `　${addLink(link.url, link.label)}`)
  ];

  if (
    !includeExpress ||
    !notice.expressSectionTitle ||
    !notice.expressOnlyBulletLine ||
    !notice.expressAreaBulletPrefix ||
    !notice.expressAreaBulletSuffix ||
    !notice.expressInlineLink ||
    !notice.expressFooterLink
  ) {
    return lines;
  }

  lines.push(notice.expressSectionTitle);
  lines.push(notice.expressOnlyBulletLine);
  lines.push(
    `${notice.expressAreaBulletPrefix}${addLink(notice.expressInlineLink.url, notice.expressInlineLink.label)}${
      notice.expressAreaBulletSuffix
    }`
  );
  lines.push(`　${addLink(notice.expressFooterLink.url, notice.expressFooterLink.label)}`);
  return lines;
};
